var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a6 6 0 1 0 .002 12.002A6 6 0 0 0 8 2Zm0 2.661a1.016 1.016 0 1 1 0 2.033A1.016 1.016 0 0 1 8 4.66Zm1.065 6.436c.16 0 .29-.13.29-.29v-.581a.29.29 0 0 0-.29-.29h-.29v-2.42a.29.29 0 0 0-.291-.29H6.935a.29.29 0 0 0-.29.29v.58c0 .161.13.291.29.291h.29v1.548h-.29a.29.29 0 0 0-.29.29v.582c0 .16.13.29.29.29h2.13Z",
    fill: "currentColor"
  })));
};

export default SvgInfoCircle;